import React, { useState, Fragment } from 'react'

import { DataGrid } from '@mui/x-data-grid'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import _ from 'lodash'
import PencilOutline from 'mdi-material-ui/PencilOutline'
import DeleteOutline from 'mdi-material-ui/DeleteOutline'

import QuickSearchToolbar from 'views/components/QuickSearchToolbar'
import DialogModal from '@core/components/dialogmodal'
import ImageModal from '@core/components/imagemodal'
import { isPermissionAllow } from '@core/utils/IsPermissionAllow'

const renderClient = params => {
  const { row } = params

  if (row.image) {
    return <img alt='img' src={`${row.image}`} width='40px' height='40px' />
  }
}

const TeamList = props => {
  const {
    handleDeleteModal,
    deleteOpen,
    handleOpen,
    teamList,
    pageSize,
    searchText,
    pageNumber,
    setPageSize,
    setSearchText,
    setPageNumber,
    totalRecord,
    permission,
    role
  } = props

  const [deleteId, setDeleteId] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  const [openImage, setOpenImage] = useState(false)
  const [imageUrl, setImageUrl] = useState('')

  const handleEdit = id => {
    handleOpen('edit', id)
  }

  const handleDelete = id => {
    handleDeleteModal()
    setDeleteId(id)
  }

  const handleImageModal = url => {
    setImageUrl(url)
    setOpenImage(true)
  }

  const handleClose = () => {
    setOpenImage(false)
  }

  const columns = [
    {
      flex: 0.4,
      minWidth: 80,
      field: 'index',
      headerName: 'Index'
    },
    {
      flex: 1,
      minWidth: 130,
      field: 'name',
      headerName: 'Name'
    },
    {
      flex: 1,
      minWidth: 150,
      field: 'phone_no',
      headerName: 'Phone',
      renderCell: ({ row }) => {
        return (
          <Box>
            {row?.country_code && row?.phone_no && (
              <Typography sx={{ fontSize: '0.92rem !important' }}>
                +{row.country_code}-{row.phone_no}
              </Typography>
            )}
          </Box>
        )
      }
    },
    {
      flex: 1,
      minWidth: 130,
      field: 'designation',
      headerName: 'designation'
    },
    {
      flex: 0.8,
      minWidth: 80,
      field: 'image',
      headerName: 'Profile',
      renderCell: params => {
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={() => handleImageModal(params.row.image)}
          >
            {renderClient(params)}
          </Box>
        )
      }
    },
    {
      flex: 0.5,
      minWidth: 100,
      field: 'priority',
      headerName: 'priority'
    },
    {
      flex: 0.7,
      minWidth: 100,
      field: 'action',
      headerName: 'Actions',
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}
            >
              {((permission.edit && role === '2') || role === '1') && (
                <IconButton onClick={() => handleEdit(row.id)}>
                  <PencilOutline fontSize='medium' />
                </IconButton>
              )}
              {((permission.delete && role === '2') || role === '1') && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize='medium' />
                </IconButton>
              )}
            </Box>
          </Box>
        )
      }
    }
  ]
  const removeaction =
    !permission.edit && !permission.delete && role === '2'
      ? _.dropRight(columns)
      : columns
  const handleSearch = searchValue => {
    setSearchText(searchValue)
  }

  const assemList = teamList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      ...data
    }
  })

  return (
    <Fragment>
      <Card sx={{ width: '100%', overflowInline: 'hidden' }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: 'No results found' }}
          columns={removeaction}
          page={pageNumber}
          rows={assemList}
          pageSize={pageSize}
          rowCount={Number(totalRecord)}
          rowsPerPageOptions={[10, 25, 50]}
          components={{ Toolbar: QuickSearchToolbar }}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          pagination
          paginationMode="server"
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              value: searchText,
              clearSearch: () => handleSearch(''),
              onChange: event => handleSearch(event.target.value),
              handleOpen: () => handleOpen('add'),
              title: isPermissionAllow(permission.edit, role) ? 'Add Team' : '',
              selectedRows: selectedRows,
              multiDelete: isPermissionAllow(permission.delete, role),
              onClickDelete: () => handleDeleteModal(),
            },
          }}
          sx={{
            '.MuiTablePagination-displayedRows': {
              marginTop: '1rem'
            },
            '.MuiTablePagination-selectLabel': {
              marginTop: '1.1rem'
            },
            '.MuiInputBase-root': {
              marginTop: '0.2rem'
            }
          }}
        />
      </Card>

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows
            )
          }
        />
      )}

      {openImage && (
        <ImageModal
          open={openImage}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      )}
    </Fragment>
  )
}

export default TeamList
